module.exports = "tinymce::ng-deep #mceu_4 button {\n  width: 60px; }\n"